import React, { FC } from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import CalculatorIframe from "../CalculatorIframe";

interface IEarningsCalculatorSectionProps {}

const EarningsCalculatorSection: FC<IEarningsCalculatorSectionProps> = () => {
  return (
    <section
      style={{
        background: "linear-gradient(rgb(29, 194, 186), rgb(21, 36, 66))",
        padding: "100px 0",
      }}
    >
      <Container maxWidth="lg">
        <Box mb={4} textAlign="center">
          <Typography
            variant="h2"
            style={{
              color: "#ffffff",
              fontWeight: 500,
              marginBottom: 16,
              letterSpacing: -1,
            }}
          >
            Earnings Calculator
          </Typography>
          <Typography
            variant="h5"
            style={{
              color: "rgba(255, 255, 255, 0.85)",
              maxWidth: 820,
              margin: "0 auto",
              lineHeight: 1.4,
            }}
          >
            Show artists exactly what they would earn on StarFarm compared to
            major platforms before they decide to join.
          </Typography>
        </Box>

        <Box
          style={{
            borderRadius: 16,
            overflow: "hidden",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            boxShadow: "0 18px 40px rgba(2, 22, 43, 0.45)",
            backgroundColor: "#0b0d20",
          }}
        >
          <CalculatorIframe />
        </Box>
      </Container>
    </section>
  );
};

export default EarningsCalculatorSection;
